module.exports = __webpack_public_path__ + "static/media/01B.51859ac8.png";